export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7567.9b58905c.jpg";